<template>
  <e-collapse title="基础设置" :expand="true">
    <t-form-item label="label">
      <t-input size="small" v-model="attribute.label" />
    </t-form-item>
        <t-form-item label="显示label">
      <t-switch
        v-model="attribute.labelBoolean"
        size="small"
        :label="['显示', '关闭']"
      />
    </t-form-item>
    <t-form-item label="label宽度">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.labelWidth"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="label位置">
      <t-radio-group size="small" v-model="attribute.labelAlign">
        <t-radio-button value="left">左部</t-radio-button>
        <t-radio-button value="right">右部</t-radio-button>
        <t-radio-button value="top">顶部</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="单选类型">
      <t-radio-group size="small" v-model="attribute.radioType">
        <t-radio-button value="radio">常规型</t-radio-button>
        <t-radio-button value="button">按钮型</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="选项间距" v-if="attribute.radioType == 'radio'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.radioSpace"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="布局方式" v-show="attribute.radioType == 'button'">
      <t-radio-group size="small" v-model="attribute.layout" @change="changeLayout">
        <t-radio-button value="row">横向</t-radio-button>
        <t-radio-button value="column">竖向</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="横向滚动条" v-show="attribute.layout == 'row'">
      <t-switch v-model="attribute.rowScroll" size="small" :label="['开', '关']" />
    </t-form-item>
    <t-form-item label="纵向滚动条" v-show="attribute.layout == 'column'">
       <t-switch v-model="attribute.columnScroll" size="small" :label="['开', '关']" />
    </t-form-item>
    <t-form-item label="尺寸">
      <t-radio-group size="small" v-model="attribute.size" @change="changeSize">
        <t-radio-button value="small">小</t-radio-button>
        <t-radio-button value="medium">中</t-radio-button>
        <t-radio-button value="large">大</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="宽度" v-show="attribute.radioType == 'radio'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.width"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="高度" v-show="attribute.radioType == 'radio'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.height"
        :decimal-places="0"
      />
    </t-form-item>
     <t-form-item label="宽度" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.buttonWidth"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="高度" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.buttonHeight"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="上间距" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.buttonTop"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="下间距" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.buttonButtom"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="左间距" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.buttonLeft"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="右间距" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.buttonRight"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="背景颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.bgColor"
        size="small"
      />
    </t-form-item>
    <!-- <t-form-item label="圆角">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.borderRadius"
        :decimal-places="0"
      />
    </t-form-item> -->
  </e-collapse>
  <!-- <e-collapse title="未选中设置" :expand="true">
      <t-form-item label="背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.bgColor"
          size="small"
        />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.brColor"
          size="small"
        />
      </t-form-item>
    </e-collapse>-->
  <e-collapse title="字体设置" :expand="true">
    <t-form-item label="字体颜色">
      <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.textColor"
      />
    </t-form-item>
    <t-form-item label="字体样式">
      <t-radio-group size="small" v-model="attribute.fontStyle">
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="italic">斜体</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="加粗">
      <t-radio-group size="small" v-model="attribute.fontWeight">
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="bold">加粗</t-radio-button>
        <t-radio-button value="lighter">更细</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="字体">
      <t-select size="small" v-model="attribute.fontFamily">
        <t-option
          v-for="item in textFamilyList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </t-select>
    </t-form-item>
    <t-form-item label="字体大小">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.fontSize"
        :decimal-places="0"
      />
    </t-form-item>
  </e-collapse>
  <e-collapse
    title="边框设置"
    :expand="true"
  >
    <t-form-item label="边框宽度" v-show="attribute.radioType == 'radio'">
      <t-input-number
        size="small"
        v-model="attribute.borderSize"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item>
        <t-form-item label="边框宽度" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        v-model="attribute.buttonBorderSize"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="边框颜色">
      <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.borderColor"
      />
    </t-form-item>
    <t-form-item label="边框圆角" v-show="attribute.radioType == 'radio'">
      <t-input-number
        size="small"
        v-model="attribute.borderRadius"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item>
      <t-form-item label="边框圆角" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        v-model="attribute.buttonBorderRadius"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="线条类型">
      <t-select size="small" v-model="attribute.lineType">
        <t-option
          v-for="item in lineTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </t-select>
    </t-form-item>
  </e-collapse>
  <e-collapse title="选中设置" :expand="true">
     <t-form-item label="选中字体颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.activeTextColor"
        size="small"
      />
    </t-form-item>
    <t-form-item label="选中背景颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.activeBgColor"
        size="small"
      />
    </t-form-item>
    <t-form-item label="选中颜色" v-show="attribute.radioType == 'radio'">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.activeBg"
        size="small"
      />
    </t-form-item>
    <t-form-item label="选中边框宽度" v-show="attribute.radioType == 'radio'">
      <t-input-number
        size="small"
        v-model="attribute.activeBorderSize"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="选中边框宽度" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        v-model="attribute.buttonActiveBorderSize"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item> 
    <t-form-item label="选中边框颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.activeBorderColor"
        size="small"
      />
    </t-form-item>
    <t-form-item label="选中边框圆角" v-show="attribute.radioType == 'radio'">
      <t-input-number
        size="small"
        v-model="attribute.activeBorderRadius"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item>
     <t-form-item label="选中边框圆角" v-show="attribute.radioType == 'button'">
      <t-input-number
        size="small"
        v-model="attribute.ButtonActiveBorderRadius"
        :min="0"
        :max="9999"
        :decimal-places="0"
      />
    </t-form-item>
    <t-form-item label="选中线条类型">
      <t-select size="small" v-model="attribute.activeLineType">
        <t-option
          v-for="item in lineTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </t-select>
    </t-form-item>
  </e-collapse>
  <e-collapse title="校验设置" :expand="true">
    <t-form-item label="必填标识">
      <t-switch
        size="small"
        v-model="attribute.required"
        :label="['是', '否']"
      />
    </t-form-item>
  </e-collapse>
</template>

<script>
export default {
  name: "cpt-radio-option-base",
  props: {
    attribute: Object,
    currentCpt: Object,
  },
  created() {
    this.textFamilyList = require("@/assets/font/font-list");
    this.lineTypeList = require("@/assets/data/line-type");
  },
  methods: {
    changeSize(val) {
      this.$emit("changeSize", val);
    },
    changeLayout(val) {
       this.$emit("changeLayout", val);
    }
  },
};
</script>

<style>
</style>